/**
 * Created by MRQ on 2016/1/15.
 */
"use strict";
angular.module('myZoneRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state("front.myzone", {
            url: '/myzone',
            views: {
                'main@front': {
                    templateUrl: './myZone/index_tpl.html',
                    controller: 'myZoneController'
                },
                'main@front.myzone': {
                    templateUrl: './myZone/main_tpl.html',
                    controller: 'myZoneMainCtrl'
                }
            }
        });
    }]);